import stringUtils from './stringUtils';

type GetLeadCountHeadingArgs = {
  totalLeadCount: number | null | undefined;
  isLoading: boolean;
  hasError: boolean;
};

// The count renders whenever it's available — it does NOT depend on a property being selected.
// In v2's all-listings view no single listing is selected but the backend still returns a total,
// so gating on listing selection would wrongly hide the count there.
export default function getLeadCountHeading({ totalLeadCount, isLoading, hasError }: GetLeadCountHeadingArgs): string {
  if (hasError || isLoading || totalLeadCount == null) return 'Leads';
  return `${totalLeadCount} ${stringUtils.pluralize('Lead', totalLeadCount)}`;
}
